import React from "react";

import useObserver from "bodycodi/cmap/app/components/common/useObserver";
import Member from "bodycodi/cmap/app/components/common/Member";
import MemberPass from "bodycodi/cmap/app/components/common/MemberPass";

interface MemberList {
  memberList: Array<string>;
  scrollEnd: boolean;
  loading: boolean;
  listSize: number;
  isDone: boolean;
  isBan: boolean;
  fetchMembers: any;
  from: string;
  chooseMemberList: any;
  onClickMember: any;
}

const MemberList = ({
  memberList,
  isDone,
  scrollEnd,
  loading,
  listSize,
  isBan,
  fetchMembers,
  from,
  chooseMemberList,
  onClickMember,
}: MemberList) => {
  const [_, setRef] = useObserver(async (entry: any, observer: any) => {
    if (entry.isIntersecting && !loading && !isDone && !isBan) {
      observer.unobserve(entry.target);
      fetchMembers("add");
      observer.observe(entry.target);
    }
  }, {});

  return (
    <div className="member-mngt-list">
      {memberList.map((d: any) =>
        from === "schedulePass" ? (
          <MemberPass key={d.seqMember} d={d} clickPass={onClickMember} />
        ) : (
          <Member
            key={d.seqMember}
            d={d}
            from={from}
            isChecked={chooseMemberList[d.seqMember] ? true : false}
            onClickMember={onClickMember}
          />
        )
      )}
      {loading &&
        [...Array(listSize)].map((d, i) => (
          <div className="member-mngt" key={i}>
            <div className="profile-wrap">
              <div className="profile skeleton" />
            </div>
            <div className="text">
              <div className="title skeleton"></div>
              <div className="desc skeleton"></div>
            </div>
          </div>
        ))}

      {memberList.length === 0 && !loading && (
        <div className="member-empty">내 관리회원이 없습니다.</div>
      )}
      {!scrollEnd && <div ref={setRef}></div>}
    </div>
  );
};

export default MemberList;
